<template>
  <TemplateDefault>
    <template #breadcrumbHeader>
      <StoriesBreadcrumb />
    </template>

    <template #pageHeading>
      <PageHeadingDefault>
        特集一覧
      </PageHeadingDefault>
    </template>

    <template #main>
      <StoriesMain />
    </template>

    <template #breadcrumbFooter>
      <StoriesBreadcrumb />
    </template>
  </TemplateDefault>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import StoriesBreadcrumb from '../stories/Breadcrumb.vue'
import StoriesMain from '../stories/Main.vue'
import PageHeadingDefault from '@/components/_core/PageHeadingDefault.vue'

export default defineComponent({
  name: 'StoriesApp',

  components: {
    StoriesBreadcrumb,
    StoriesMain,
    PageHeadingDefault,
  },
})
</script>

